import React from 'react';
import {
  SelectField,
  MenuItem,
  RadioButtonGroup,
  RadioButton,
} from 'material-ui';
import { isEqual } from 'lodash';
import { ProductsField, ChipRenderer } from './components';
import { filterChosenItems, getDefaultProducts, filterByCategory, getDrinksProducts, getFoodProducts } from './utils';
import { getTranslationByLocale } from '../../utils/TranslationUtils';


class ProductsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radioChoice: 'allProducts',
      products: this.props.products,
      categories: this.props.categoriesByMarket,
    };
  }

  componentDidMount = () => {
    const { radioChoice } = this.state;
    if (radioChoice === 'allProducts') {
      this.setState({ products: this.props.productsByMarket });
    }
  }

  componentWillReceiveProps = (nextProps) => { // eslint-disable-line consistent-return
    if (!isEqual(this.props.market, nextProps.market)) {
      if (this.state.radioChoice === 'allProducts') {
        this.setState({ products: nextProps.productsByMarket }, () => this.props.handleProductsChange(this.state.products, true));
      }
      if (this.state.radioChoice === 'products') {
        this.setState({ products: [] }, () => this.props.handleProductsChange(this.state.products, false));
      }
      if (this.state.radioChoice === 'categories') {
        this.setState({ products: [], categories: [] }, () => this.props.handleProductsChange(this.state.products, false));
      }
      if (this.state.radioChoice === 'defaultProducts') {
        this.setState({ products: getDefaultProducts(nextProps.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false));
      }
      if (this.state.radioChoice === 'drinks') {
        this.setState({ products: getDrinksProducts(nextProps.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false, true));
      }
      if (this.state.radioChoice === 'food') {
        this.setState({ products: getFoodProducts(nextProps.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false, false));
      }
    }
    if (!isEqual(this.props.products, nextProps.products)) {
      if (this.state.radioChoice === 'allProducts') {
        return this.setState({ products: nextProps.productsByMarket }, () => this.props.handleProductsChange(this.state.products, true));
      }
      if (this.state.radioChoice === 'products') {
        return this.setState({ products: nextProps.products }, () => this.props.handleProductsChange(this.state.products, false));
      }
    }
    if (!isEqual(this.props.productsByMarket, nextProps.productsByMarket)) {
      if (this.state.radioChoice === 'allProducts') {
        return this.setState({ products: nextProps.productsByMarket }, () => this.props.handleProductsChange(this.state.products, true));
      }
    }
  }

  handleRadioChange = (event, value) => {
    if (value === 'allProducts') {
      this.setState({ radioChoice: value, products: this.props.productsByMarket }, () => this.props.handleProductsChange(this.state.products, true));
    }
    if (value === 'products') {
      this.setState({ radioChoice: value, products: [] }, () => this.props.handleProductsChange(this.state.products, false));
    }
    if (value === 'categories') {
      this.setState({ radioChoice: value, products: [] }, () => this.props.handleProductsChange(this.state.products, false));
    }
    if (value === 'defaultProducts') {
      this.setState({ radioChoice: value, products: getDefaultProducts(this.props.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false));
    }
    if (value === 'drinks') {
      this.setState({ radioChoice: value, products: getDrinksProducts(this.props.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false, true));
    }
    if (value === 'food') {
      this.setState({ radioChoice: value, products: getFoodProducts(this.props.productsByMarket) }, () => this.props.handleProductsChange(this.state.products, false, false));
    }
  }

  handleSelectProduct = (product) => {
    const { products } = this.state;
    products.push(product);
    this.setState({ products, searchProducts: '' }, () => this.props.handleProductsChange(this.state.products, false));
  }

  handleSearch = (searchText) => {
    this.setState({ searchProducts: searchText });
  }

  handleRemoveChip = (id) => {
    const { products } = this.state;
    const filteredProducts = products.filter((item) => item._id !== id);
    this.setState({ products: filteredProducts }, () => this.props.handleProductsChange(this.state.products, false));
  }

  handleCategoryChange = (event, index, value) => { // value is an array of selected categories
    const { productsByMarket } = this.props;
    const filteredProducts = filterByCategory(productsByMarket, value);
    this.setState({ categories: value, products: filteredProducts }, () => this.props.handleProductsChange(this.state.products, false));
  }

  render() {
    const { locale, translate, productsByMarket, categoriesByMarket } = this.props;
    const { products, categories, radioChoice } = this.state;
    return (
      <div className="products">
        <h2>{translate('statistics.products')}</h2>
        <RadioButtonGroup
          onChange={this.handleRadioChange}
          name="venuesRadio"
          defaultSelected="allProducts"
          className="radio-button-group"
        >
          <RadioButton
            value="allProducts"
            label={translate('statistics.allProducts')}
          />
          <RadioButton
            value="products"
            label={translate('statistics.products')}
          />
          <RadioButton
            value="categories"
            label={translate('statistics.categories')}
          />
          <RadioButton
            value="defaultProducts"
            label={translate('statistics.defaultProducts')}
          />
          <RadioButton
            value="food"
            label={translate('statistics.food')}
          />
          <RadioButton
            value="drinks"
            label={translate('statistics.drinks')}
          />
        </RadioButtonGroup>

        {
          radioChoice === 'products' && (
            <ProductsField
              choices={filterChosenItems(productsByMarket, products)}
              handleSelectProduct={this.handleSelectProduct}
              handleSearch={this.handleSearch}
              searchText={this.state.searchProducts}
            />
          )
        }

        {
          radioChoice === 'categories' && (
            <div className="field-wrapper">
              <SelectField value={categories} multiple onChange={this.handleCategoryChange} floatingLabelText={translate('statistics.selectCategory')}>
                {
                  categoriesByMarket.map((cat) => (
                    <MenuItem key={cat._id} checked={categories && categories.indexOf(cat._id) > -1} primaryText={getTranslationByLocale(cat.title, locale)} value={cat._id} />
                  ))
                }
              </SelectField>
            </div>
          )
        }
        <div className="field-wrapper">
          <ChipRenderer handleRequestDelete={this.handleRemoveChip} values={this.state.products} translate={translate} source={translate('statistics.products')} locale={locale} />
        </div>
      </div>
    );
  }
}

export default ProductsComponent;
